import React from 'react';
import { ToggleButtonGroup, ToggleButton, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    borderRadius: 20,
    overflow: 'hidden',
    border: '1px solid #ccc',
    backgroundColor: '#f9f9f9',

    '& .MuiToggleButton-root': {
        borderRadius: 0,
        fontWeight: 500,
        fontSize: '14px',
        textTransform: 'none',
        padding: '6px 16px',
        color: '#333',
        '&:not(:last-of-type)': {
            border: 'none',
        },
        '&.Mui-selected': {
            backgroundColor: '#c70909',
            color: '#fff',
            fontWeight: 600,
            borderRadius: '20px'
        },
    },
}));

const TypeToggleSwitch = ({ label = "Type", value, onChange, options }) => {
    const handleTypeChange = (event, newValue) => {
        if (newValue !== null) {
            onChange(newValue);
        }
    };

    return (
        <Box className="field">
            <Typography  sx={{
              color:  '#555',
              fontSize:'0.9rem',
              fontFamily:'"Nunito" !important'
                }} mb={0.5}>{label}</Typography>
            <StyledToggleButtonGroup
                size="small"
                exclusive
                value={value || ''}
                onChange={handleTypeChange}
                aria-label={`${label} toggle`}
            >
                {options.map((option) => (
                    <ToggleButton key={option.value} value={option.value}>
                        {option.label}
                    </ToggleButton>
                ))}
            </StyledToggleButtonGroup>
        </Box>
    );
};

export default TypeToggleSwitch;
